import { useMemo } from 'react';
import * as THREE from 'three';
import { Line } from '@react-three/drei';
import { useAppStore } from '@/state/store';

/**
 * Draws the trimmed profile as a thin line along the top of the bat
 * (radius plotted directly, at z=0) so an operator can visually confirm the
 * generated mesh matches the source coordinates exactly.
 */
export function ProfileOverlayLine() {
  const model = useAppStore((s) => s.model);
  const show = useAppStore((s) => s.viewer.profileOverlay);

  const points = useMemo(() => {
    if (!model) return [];
    const pts = model.normalized.points;
    if (pts.length === 0) return [];
    const first = pts[0];
    const last = pts[pts.length - 1];
    const length = last.position - first.position;
    const centerOffset = length / 2;
    // Mesh is centered along X in buildLatheGeometry, so re-derive the same
    // centering here: x runs knob(0) -> tip(length), then shift by -length/2.
    return pts.map((p) => new THREE.Vector3(p.position - centerOffset, p.radius, 0));
  }, [model]);

  if (!show || points.length < 2) return null;

  return <Line points={points} color="#5c93c4" lineWidth={1.5} transparent opacity={0.85} />;
}
